import BaseContentDetailsDetailsSubPageView from "scripts/views/baseContentDetailsDetailsSubPageView";
import CitationsView from "scripts/views/citationsView";
import templateContentDetailsChapterPageDetailsSubPage from "templates/contentDetailsChapterPageDetailsSubPage.hbs";
import templateCategoryLink from "templates/categoryLink.hbs";
import ContentDetailsBookPageDetailsSubPageView from "scripts/views/contentDetailsBookPageDetailsSubPageView";

class ContentDetailsChapterPageDetailsSubPageView extends BaseContentDetailsDetailsSubPageView {
  get template() {
    return templateContentDetailsChapterPageDetailsSubPage;
  }

  get categoryTemplate() {
    return templateCategoryLink;
  }

  constructor(options) {
    super(options);

    this.citationsView = this.addSubView(
      new CitationsView({
        mediaId: this.model.get("id"),
      }),
    );
  }

  render() {
    return ContentDetailsBookPageDetailsSubPageView.prototype.render.call(this);
  }

  addCategories(categories) {
    return ContentDetailsBookPageDetailsSubPageView.prototype.addCategories.call(
      this,
      categories,
    );
  }
}

export default ContentDetailsChapterPageDetailsSubPageView;
